import { render, staticRenderFns } from "./setSkin.vue?vue&type=template&id=475b6b48&scoped=true&"
import script from "./setSkin.vue?vue&type=script&lang=js&"
export * from "./setSkin.vue?vue&type=script&lang=js&"
import style0 from "./setSkin.vue?vue&type=style&index=0&id=475b6b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b6b48",
  null
  
)

export default component.exports